<template>
  <div class="box" style="position: relative">
    <div class="columns">
      <div class="column">
        <b-field label="First Name">
          <p>{{ feedbackGiver.first_name }}</p>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Last Name">
          <p>{{ feedbackGiver.last_name }}</p>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field label="Email">
          <p>{{ feedbackGiver.email }}</p>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Relationship to you">
          <p>
            {{
              relationships.find(
                ({ id }) => id == feedbackGiver.pivot.relationship_id
              ).name
            }}
          </p>
        </b-field>
      </div>
    </div>
    <b-loading
      :is-full-page="false"
      :active="loading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
export default {
  props: {
    feedbackGiver: Object,
    relationships: Array,
    loading: Boolean,
  },
};
</script>
